import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { range, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'app/main/services/app.service';
import { ChangeDetectorRef } from '@angular/core';
import { DatasetService } from 'app/main/services/dataset.service';
import { HttpHeaders } from '@angular/common/http';

@Component({
	selector: 'custom-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

	isToggleActive: any = {
		'supporto': false, 
		'azienda': false, 
		'info': false,
		'legal_info': false,
	};

	_unsubscribeAll: Subject<any>;

	public links: any
	public entity: any;
	constructor(
		private datasetService: DatasetService, 
		public appService: AppService, 
		private cdRef: ChangeDetectorRef
	) {
		this._unsubscribeAll = new Subject<any>();
	}

	ngOnInit(): void {
		this.appService.appData.subscribe(appData => {
			this.entity = appData.entity;
		});

		this.getLinks();
		// reload data with new language
		this.appService.onLanguageChange
		.pipe(takeUntil(this._unsubscribeAll))
		.subscribe((newLang) => {
			if (newLang) this.getLinks();
		});
	}

	get Address(): string{
		const street = this.entity.street;
		const number = this.entity.number;
		const zip_code = this.entity.zip_code;
		const locality = this.entity.locality;
		const province = this.entity.province;
		if (street && number && zip_code && locality && province){
			return street + ', ' + number + ' - ' + zip_code + ' ' + locality + ' ' + '(' + province + ')';
		}
		return '';
	}

	get Year(): any{
		return new Date().getFullYear();
	}

	toggleContent(content: string): void{
		if (this.isToggleActive[content]){
			this.isToggleActive[content] = false;
		} else {
			this.isToggleActive[content] = true;
		}
		this.cdRef.detectChanges();
	}

	public getLinks(): void {
		this.datasetService.get('/links')
		.subscribe({
			next: (response) => {
				this.links = response
			}
		});
	}

}
